import { Injectable } from '@angular/core';
import { Ticket } from '../../domain/model/ticket.model';

@Injectable({ providedIn: 'root' })
export class TicketMergeService {

  merge(serverTickets: Ticket[], localTickets: Ticket[]): Ticket[] {
    const merged = this.initializeWith(serverTickets);

    this.mergeWithLocalTickets(merged, localTickets);

    return this.toArray(merged);
  }

  private initializeWith(tickets: Ticket[]): Map<string, Ticket> {
    return new Map(tickets.map(ticket => [ticket?.id, ticket]));
  }

  private mergeWithLocalTickets(merged: Map<string, Ticket>, localTickets: Ticket[]): void {
    localTickets.forEach(local => this.updateIfNewer(merged, local));
  }

  private updateIfNewer(merged: Map<string, Ticket>, localTicket: Ticket): void {
    const existing = merged.get(localTicket?.id);

    if (!existing || this.isNewer(localTicket, existing)) {
      merged.set(localTicket?.id, localTicket);
    }
  }

  private isNewer(candidate: Ticket, current: Ticket): boolean {
    return candidate.updatedAt > current.updatedAt;
  }

  private toArray(merged: Map<string, Ticket>): Ticket[] {
    return Array.from(merged.values());
  }
}
